
// import { createLocation } from "history";

// export const resolveToLocation = (to, currentLocation) =>
//   typeof to === "function" ? to(currentLocation) : to;

// export const normalizeToLocation = (to, currentLocation) => {
//   return typeof to === "string"
//     ? createLocation(to, null, null, currentLocation)
//     : to;
// };


// import { useLocation } from "react-router-dom";

export const resolveToLocation = (to, currentLocation) =>
  typeof to === "function" ? to(currentLocation) : to;

export const normalizeToLocation = (to, currentLocation) => {
  return typeof to === "string"
    ? { pathname: to, state: null } // React Router v6 uses objects, not createLocation
    : to;
};